const mapSectionsWithComponents = (data = []) => {
  const sections = {};

  if (!Array.isArray(data)) {
    return sections;
  }

  data.forEach((blockComponent) => {
    const type = blockComponent.type[0].target_id;
    const uuid = blockComponent.uuid[0].value;
    const parentUuid =
      blockComponent.behavior_settings[0].value.layout_paragraphs.parent_uuid;
    const { region } =
      blockComponent.behavior_settings[0].value.layout_paragraphs;

    if (type === 'block_section') {
      if (blockComponent.components) {
        blockComponent.components = {};
      }

      sections[`${uuid}`] = blockComponent;
    } else {
      sections[`${parentUuid}`].components =
        sections[`${parentUuid}`].components || {};
      sections[`${parentUuid}`].components[`${region}`] =
        sections[`${parentUuid}`].components[`${region}`] || [];

      sections[`${parentUuid}`].components[`${region}`].push(blockComponent);
    }
  });

  // Clean up sections without components.
  Object.entries(sections).forEach(([key, value]) => {
    if (!value.components) {
      delete sections[key];
    }
  });

  return sections;
};

export default mapSectionsWithComponents;
